export default __webpack_public_path__ + "static/media/Queens University.93eee770.png";